/**
 * @author varun
 */
angular.module('AppCtrl.campaign.constant',[ 'jv.Common.i18n']).
    constant('campaignStatusPrettyMap', function(val) {
        if(val === "IN_PROGRESS") return "ACTIVE";
        else return "INACTIVE";
    }).
    constant('campaignTypePrettyMap', function(val) {
        if(val === "WEBSITE") return "CAMPAIGN_TYPE_WEB_PAGE";
        else if (val === "SOCIAL") return "CAMPAIGN_TYPE_SOCIAL_MEDIA";
        else if (val === "EMAIL") return "CAMPAIGN_TYPE_EMAIL";
        else return "";
    }).
    service('constantService',['i18n', function(i18n) {
        return {
            'TEMPLATE_COPIED':i18n['TEMPLATE_COPIED_MSG'],
            'TEMPLATE_NOT_COPIED':i18n['TEMPLATE_NOT_COPIED_MSG'],
            'TEMPLATE_SAVED':i18n['TEMPLATE_SAVED_MSG'],
            'TEMPLATE_UNSAVED':i18n['TEMPLATE_UNSAVED_MSG'],
            'MESSAGE_TEMPLATE_UNSAVED':i18n['MESSAGE_TEMPLATE_UNSAVED_MSG'],
            'TEMPLATE_DELETE':i18n['TEMPLATE_DELETE_MSG'],
            'TEMPLATE_NOT_DELETED':i18n['TEMPLATE_NOT_DELETED_MSG'],
            'CAMPAIGN_SAVED':i18n['CAMPAIGN_SAVED_MSG'],
            'CAMPAIGN_SENT_ALL_ERROR':i18n['CAMPAIGN_SENT_ALL_ERROR_MSG'],
            'MESSAGES_HAS_ERRORS':i18n['MESSAGES_HAS_ERRORS_MSG'],
            'REGULAR_LINK_TEMPLATE': "<input style=\"font-size: 12px; color: #ffffff; text-shadow: 0px -1px 1px rgba(0, 0, 0, 0.3); border: none; padding: 5px; text-align: center; background-color: #3d87cf; border-radius: 3px; display: inline-block;\" type=\"button\" value=\"{0}\" disabled=\"disabled\" />",
            'JOIN_US_APP_TEMPLATE': "<input style=\"font-size: 12px; color: #ffffff; text-shadow: 0px -1px 1px rgba(0, 0, 0, 0.3); border: none; padding: 1px 2px; text-align: center; background-color: #3d87cf; border-radius: 3px; display: inline-block; width: 260px; height: 390px;\" type=\"button\" value=\"{0}\" disabled=\"disabled\" />",        'CAMPAIGN_SENT_ALL': "Campaign sent to all contacts.",
        };
    }]);
